// extracted by mini-css-extract-plugin
module.exports = {"PostTeaserLink__root":"XBPH","PostTeaserLink__content":"rZAP"};